<template>
  <component :is="wrapperTag" :href="link">
    <component :is="tag" :class='classes' :style="style">
      {{ text }}
    </component>
  </component>
</template>

<script>
import "./textblock.scss"

export default {
  name: 'TextBlock',
  props: {
    align: {
      type: String,
      validator(value) {
        return ['left', 'center', 'right'].includes(value)
      },
      required: false
    },
    bold: {
      type: Boolean,
      required: false
    },
    semiBold: {
      type: Boolean,
      required: false
    },
    color: {
      type: String,
      default: "black",
      required: false
    },
    extraClasses: {
      type: Object,
      default: () => {},
      required: false
    },
    fontSize: {
      type: String,
      required: false
    },
    link: {
      type: String,
      required: false
    },
    lineDecoration: {
      type: String,
      validator(value) {
        return ['over', 'under'].includes(value)
      },
      required: false
    },
    size: {
      type: String,
      required: false
    },
    tag: {
      type: String,
      default: 'span',
      required: false
    },
    text: {
      type: String,
      required: true
    },
  },
   computed: {
    wrapperTag() {
      return this.link ? "a" : "div"
    },
    classes() {
      return {
        [`textblock--${this.size}`]: !!this.size,
        [`textblock--line-decoration-${this.lineDecoration}`]: !!this.lineDecoration,
        [`textblock--line-decoration-${this.lineDecoration}-${this.align}`]: !!this.lineDecoration && !!this.align,
        'tw-text-darkblue': this.color === "darkblue",
        'tw-text-black': this.color === "black",
        'tw-text-white': this.color === "white",
        "tw-w-full": !!this.align,
        "tw-block": !!this.align,
        "tw-font-bold": this.bold,
        "tw-font-semibold": this.semiBold,
        ...this.extraClasses
      };
    },
    style() {
      return {
        fontSize: this.fontSize,
        textAlign: this.align || "left"
      };
    },
  }
}
</script>
